import { render, staticRenderFns } from "./users-data.vue?vue&type=template&id=59b9e923"
import script from "./users-data.vue?vue&type=script&lang=js"
export * from "./users-data.vue?vue&type=script&lang=js"
import style0 from "./users-data.vue?vue&type=style&index=0&id=59b9e923&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports